export enum AppInsightEvent {
  APPLY_FILTERS = 'Apply filters',
  DOWNLOAD_EXCEL = 'Download excel',
  SIMULATE_PRICE = 'Simulate price',
  SWAP_FILTERS = 'Swap filters',
  TOP_SWAP_EYE_CLICK = 'Top swap eye click',
  SEARCH = 'Search',
  SEARCH_NAVIGATION = 'Search navigation',
  BATCH_ANALYSIS = 'Batch analysis',
  BATCH_ANALYSIS_RESULTS = 'Batch analysis results',
}
